import { BOPerson } from "./BOPerson.model";

export class BOChControl {
    id:number;
    tempId?:string;
    clinicHistoryId:number;
    patientId:number;
    controlNumber:number;
    patient?:BOPerson;
    professionalId:number;
    profesional?:BOPerson;
    controlDate?:Date | undefined;
    firmaDigital:string;
    details:string;
}
